
    export default {
        name: 'Tab',

        props: {
            title: {
                type: String,
                default: '',
            },
            data: {
                type: [Object, String, Number],
                default: () => ({}),
            },
            active: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isActive: false,
            };
        },
    };
